import React, { useState, useEffect } from "react";
import { cn } from "../../lib/utils";
import { useLocation, Link } from "react-router-dom";

const navLinks = [
  { href: "/", label: "Home" },
  { href: "/experience", label: "Experience" },
  { href: "/projects", label: "Projects" },
  { href: "/contact", label: "Contact" },
];

export function Header({ className, ...props }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [currentPath]);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  const isActive = (path) => currentPath === path;
  const showNav = currentPath !== "/";

  return (
    <>
      <header
        className={cn(
          "fixed inset-x-0 top-0 z-50 bg-background/80 backdrop-blur-md transition-colors duration-300",
          scrolled || isMenuOpen
            ? "border-b border-border"
            : "border-b border-transparent",
          className
        )}
        {...props}
      >
        <div className="mx-auto flex h-14 w-full max-w-[40rem] items-center justify-between px-6">
        <Link
          to="/"
          className="text-[15px] font-medium tracking-tight text-darkgray focus-ring rounded-sm"
        >
          Krushil
        </Link>

        {showNav && (
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={cn(
                  "text-[13px] transition-colors focus-ring rounded-sm",
                  isActive(link.href)
                    ? "text-darkgray"
                    : "text-lightgray hover:text-darkgray"
                )}
                aria-current={isActive(link.href) ? "page" : undefined}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        )}

        {showNav && (
          <button
            className="md:hidden text-[13px] text-gray hover:text-darkgray focus-ring rounded-sm min-h-[44px] px-1"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-expanded={isMenuOpen}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? "Close" : "Menu"}
          </button>
        )}
        </div>
      </header>
      {showNav && isMenuOpen && (
        <nav className="md:hidden fixed inset-x-0 top-14 bottom-0 z-40 bg-background">
          <div className="mx-auto w-full max-w-[40rem] px-6 py-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={cn(
                  "block py-3 text-[15px] focus-ring rounded-sm",
                  isActive(link.href) ? "text-darkgray" : "text-gray"
                )}
                aria-current={isActive(link.href) ? "page" : undefined}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </>
  );
}
